$(document).ready(function () {
  // Trigger saat tombol diklik
  $("#accountUpdateBtn").on("click", function () {
    var inputData = {
      birthdate: $("#updateForm-BirthDate").val(),
      gender: $("#updateForm-Gender").val(),
      occupation: $("#updateForm-Occupation").val(),
      kecamatan: $("#updateForm-Kecamatan").val(),
      city: $("#updateForm-City").val(),
      province: $("#updateForm-Province").val(),
      customer_id: $("#updateForm-customerId").val(),
    };
    // Pengecekan apakah ada field yang kosong
    if (!inputData.birthdate || !inputData.gender || !inputData.occupation) {
      $("#responseMessage").html(
  '<p style="color:red;">Please complete all required fields: Birthdate, Gender, and Occupation. Try again.</p>'
);
      return; // Menghentikan eksekusi lebih lanjut jika ada field yang kosong
    }
    const popupContainer = document.getElementById("overlay");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const campaign = urlParams.get("campaign");
    var apiUrl = "https://madeforhmns-dashboard.com/api/customer/update";

    // Mengirim data menggunakan AJAX
    $.ajax({
      url: apiUrl,
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(inputData),
      success: function (response) {
        // Menangani respons sukses
        $("#responseMessage").html("<p>Success update profile, Thankyou</p>");

        if (campaign === "limitedvoucher-profileupdate") {
          popupContainer.classList.remove("hidden");
        }else{
          window.location.href="/account/addresses";
        }
      },
      error: function (xhr, status, error) {
        // Menangani respons error
        $("#responseMessage").html(
          '<p style="color:red;">Error: Sorry, please try again </p>'
        );
      },
    });
  });
});
